// ***********************************
// BatchAdd.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">
      <div>
        <router-link :to="{ name: 'BatchHome'}">List</router-link> | 
        <router-link :to="{ name: 'BatchAdd'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> 
      </div>
      <br/>

      <b-alert :show="showAlert" :variant="alertStyle">{{alertText}}
      <div v-show="showAlert && alertStyle=='success'">
          <router-link :to="{ name: 'BatchHome' }">Click here to continue</router-link>
      </div>
      </b-alert>
      <b-card v-if="!showAlert" header="Add a batch of databases">
        Switch to the <router-link :to="{ name: 'Add'}">add one database at a time</router-link> feature, or <router-link :to="{ name: 'BatchDefine'}">define a batch from some of the existing databases</router-link> that have already been uploaded.<br/><br/>

        Hint: You can still use this batch add feature even if you individually/manually collected the DBCSI output files without using the batch script.  You just need to zip the output files together and upload the zip file in Step 5 below.<br/><br/>


        <b-list-group>
          <b-list-group-item>
            <div>
              <b>First, select the type of database you are investigating.</b>
              <p/>
              <b-form-select v-model="selected" class="mb-3">
                <option value="null">Please select your database type</option>
                <option value="ora_v1">Oracle Standard or Enterprise Edition (AWR or STATSPACK)</option>
                <option value="msft_v1" disabled>Microsoft SQL Server</option>
              </b-form-select>
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Second, download and unzip the batch collection zip file for your database type.</b>
              <b-card bg-variant="light" v-if="(selected=='ora_v1')">
                Download the Oracle batch_ora data collection zip file from
                <a
                  href="/batch_ora.zip" target="_blank"
                >here</a>.  Then unzip it to find a shell script, SQL script, properties file, and README.
              </b-card>
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Third, edit the batch_ora.properties properties file to add a list of your databases and their connection information.</b>
              <b-card
                bg-variant="light"
                v-if="(selected=='ora_v1')"
              >Instructions: See the README in the downloaded batch_ora.zip file for more information.
              <br>
            </b-card>
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Fourth, run the shell script.  It will connect to each of the databases you listed in the properties file and generate a consolidated output file of metrics.</b>
              <b-card
                bg-variant="light"
                v-if="(selected=='ora_v1')"
              >Instructions: Run the batch_ora.sh shell script.</b-card>
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Fifth, provide some additional details and upload your batch collection output file.</b>
              <b-card bg-variant="light" class="text-left" v-if="(selected=='ora_v1')">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">

                  <b-form-group id="exampleInputGroup2" label="Customer Name:" label-for="customer">
                    <b-form-input
                      id="customer"
                      type="text"
                      v-model="form.customer"
                      required
                      placeholder="Enter customer name."
                      list="my-list-id">
                    </b-form-input>
                    <datalist id="my-list-id">
                      <option v-for="(item, index) in this.CustomerChoices" :key="index">{{ item.value }}</option>
                    </datalist>
                  </b-form-group>

                  <b-form-group id="exampleInputGroup3" label="Batch Name:" label-for="batchname">
                    <b-form-input
                      id="batchname"
                      type="text"
                      v-model="form.batchname"
                      required
                      placeholder="Enter batch name."
                    ></b-form-input>
                  </b-form-group>

                 <b-form-group id="exampleInputGroup4" label="Description:" label-for="descr">
                    <b-form-textarea
                      id="descr"
                      v-model="form.descr"
                      required
                      placeholder="Enter a description for this batch of databases."
                      :rows="3"
                      :max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                  
<!--                 
                    <b-form-file
                      id="output_file"
                      ref="fileinput"
                      v-model="output_file"
                      :state="Boolean(output_file)"
                      required
                      placeholder="Choose a file..."
                    ></b-form-file>
                  </b-form-group> -->
                  
                  <b-form-group
                    id="exampleInputGroup5"
                    label="Select the batch output file to be uploaded.  We suggest no more than approx 75 databases per batch."
                    label-for="output_file"
                  >
                    <b-form-file
                      id="output_file"
                      ref="fileinput"
                      v-model="output_file"
                      :state="Boolean(output_file)"
                      required
                      placeholder="Choose a file... This must be a Zip file containing .out files.  Do not upload an AWR HTML Report."
                      @change="onFileChange"
                    ></b-form-file>
                    
                    <b-alert :show="showFileAlert" variant="danger">{{alertFileText}}</b-alert>
                    <img src="@/assets/warning.png" height="14px" ></img>Reminder: always use the most recent DBCSI data collection script (available to download above) for the latest features and fixes.
  
                    
                  </b-form-group>

                  <b-alert variant="danger" :show="showSampleAlert">The "sample" user is not allowed to upload new databases.  Please sign-out and create your own user.</b-alert>

                  <b-button type="submit" :disabled="showFileAlert || showSampleAlert" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                </b-form>
              </b-card>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </div>
  </div>
</template>    


<script>
import { API, Storage, Auth } from "aws-amplify";
export default {
  name: "app",
  props: ["user"],
  data() {
    return {
      selected: 'ora_v1',
      output_file: null,
      form: {
        customer: "",
        batchname: "",
        descr: ""
      },
      show: true,
      showAlert: false,
      showFileAlert: false,
      showSampleAlert: false,
      isUploading: false,
      alertText: "",
      alertStyle: "default",
      alertFileText: "",
      CustomerChoices: [
          { value: 'Customer1', text: 'Customer1' },
      ]
    };
  },
  async created() {
    // console.log("Add: I am here1");
    let name = await Auth.currentAuthenticatedUser();
    this.user = name.username;
    // console.log("this.user", this.user);
    if (this.user=="sample") {
      this.showSampleAlert = true;
    }    
    
    var tries = 10;
    while (tries > 0) {
      await API.get("dbcsiAPI", `/dbcsi/customers`)
        .then(response => {
          // console.log("Add: I am here3");
          //use .shift() to remove the first row
          var filteredItems = response.data.filter(item => item.value !== 'xxALL');
          this.CustomerChoices = filteredItems;
          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Add Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }
    
    await API.get(
        "dbcsiAPI",
        `/dbcsi/permissions`
      )
        .then(response => {
          if (response.data.racOK=="Y") {
            // console.log("Authorized for RAC.");      
            // this.showRAC = true;
          }
        })
        .catch(error => {
          console.log("BatchAdd-permissions Error:", error);
        });
    
  },
  
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },

  beforeRouteLeave (to, from , next) {
    if (this.isUploading) {
      if (!window.confirm("Do you really want to leave? The upload is not finished yet and you will lose it!")) {
        console.log("BatchAdd: Not OK to Leave");
        return;
      }
    }
    next();
  },
  
  methods: {
    preventNav(event) {
      if (!this.isUploading) return;
      console.log("BatchAdd: preventNav: Not OK to Leave");
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },

    async onFileChange(e) {
      /* https://www.raymondcamden.com/2019/05/21/reading-client-side-files-for-validation-with-vuejs */
      // console.error("hello onFileChange");
      const file = e.target.files[0];
      // console.error(file);
      if(!file ) {
        console.error("onFileChange: no file");
        this.alertFileText = "You need to select a file to upload.";
        this.showFileAlert = true;
        return;
      }

      // 7-Zip archives (signature 37 7A BC AF 27 1C) cannot be processed; check the raw bytes
      // (the text read below garbles binary bytes, so do this first on an ArrayBuffer)
      try {
        const sig = new Uint8Array(await file.slice(0, 6).arrayBuffer());
        const sevenZip = [0x37, 0x7A, 0xBC, 0xAF, 0x27, 0x1C];
        if (sig.length == 6 && sevenZip.every((b, n) => sig[n] == b)) {
          this.alertFileText = "This file is in 7-Zip format, which DBCSI cannot process.  Please re-create it as a standard .zip file (for example, in 7-Zip choose Archive format: zip, or use your operating system's built-in Compress / Send to Compressed folder) and select it again.";
          this.showFileAlert = true;
          console.log("7-Zip file detected (signature 37 7A BC AF 27 1C); DBCSI requires a standard zip file.");
          return;
        }
      } catch (sigErr) {
        console.log("onFileChange: unable to read file signature", sigErr);
      }
      // console.error("hello2 onFileChange");
      // Credit: https://stackoverflow.com/a/754398/52160
      let reader = new FileReader();
      reader.readAsText(file, "UTF-8");
      reader.onload =  evt => {
        
        // console.log("fileheader", evt.target.result.substring(0,2), evt.target.result.charCodeAt(0).toString(16), evt.target.result.charCodeAt(1).toString(16));
        
        //TODO: must not contain ustar or PaxHeader or Rar
        if ((evt.target.result.substring(0,100000).indexOf('awr-hist')>=0) || (evt.target.result.substring(0,100000).indexOf('statspack-hist')>=0) || (evt.target.result.substring(0,100000).indexOf('sqlplus.log')>=0) || (evt.target.result.substring(0,100000).indexOf('.out')>=0) ) {
          if ((evt.target.result.substring(0,400).indexOf('PaxHeader')>=0) || (evt.target.result.substring(0,400).indexOf('ustar')>=0)) {
            this.alertFileText = "This is not a true zip file.  It looks like a tar file- please use a real zip file.";
            this.showFileAlert = true;
            console.log("Not the DBCSI batch data collection file.  We see tar headers like PaxHeader and ustar:");
            console.log(evt.target.result.substring(0,400));
          } else if ( (evt.target.result.substring(0,1)=='\x1f') ) {
            this.alertFileText = "This is not a true zip file.  It looks like a gzip file and DBCSI currently can only upload true zip files.  Please use zip (not gzip and not tar) for your file.";
            this.showFileAlert = true;
            console.log("This is not a true zip file.  It looks like a gzip file- please use a real zip file.  We see the gzpip file header");
            console.log(evt.target.result.substring(0,2));
          } else if ( (evt.target.result.substring(0,4)=='Rar!') ) {
            this.alertFileText = "This is not a true zip file.  It looks like a RAR file and DBCSI currently can only upload true zip files.  Please use zip (not gzip and not tar and not RAR) for your file.";
            this.showFileAlert = true;
            console.log("This is not a true zip file.  It looks like a gzip file- please use a real zip file.  We see the RAR file header");
            console.log(evt.target.result.substring(0,4));

          } else {  
            this.alertFileText = "";
            this.showFileAlert = false;
          }
        } else {
          this.alertFileText = "This is not a DBCSI batch data collection file in ZIP format (note: 7-ZIP format files do not work).  Please review Steps 2, 3, and 4 above.  See additional message in browser's Developer Tools javascript console.";
          this.showFileAlert = true;
          console.log("Not a zip containing DBCSI batch data collection files.  We expected to see strings like awr-hist or statspack-hist or .out.  Instead we see:");
          console.log(evt.target.result.substring(0,400));
        }  
      }
      reader.onerror = evt => {
        console.error(evt);
      }
      // this.url = URL.createObjectURL(file);
    },

    async onSubmit(evt) {
      evt.preventDefault();
      let collection_type = this.selected;
      this.selected = null;
      this.alertStyle="primary";
      this.alertText = "Uploading batch collection output file... Please wait...  Large files may take many minutes to upload... Do not leave this page yet.";
      this.showAlert = true;
      this.isUploading = true;
      // console.log("BatchAdd: I am here1");
      var tries = 3;
      var success = true;
      
      /*
      var success = false;
      while (tries > 0) {
        await API.get("dbcsiAPI", `/dbcsi/collections`)
          .then(response => {
            // console.log("BatchAdd: Aurora is ready");
            //   this.collection_list = response.data;
            tries = 0;
            success = true;
          })
          .catch(error => {
            console.log("BatchAdd.vue API Error (Aurura asleep? can retry):", error);
            console.log("Will retry.  Attempts Left:", (tries-1));
          });

        tries -= 1;
      } */
      
      if (success) {
        // console.log("BatchAdd: I am here4");
        //do a put to /collections
        const putParams = {
          body: {
            db_type: "Oracle",
            customer: this.form.customer,
            batchname: this.form.batchname,
            descr: this.form.descr,
            collection_type: collection_type
          }
        };

        var new_id = null;
        var api_success = false;
        await API.put("dbcsiAPI", `/dbcsi/batch`, putParams)
          .then(response => {
            new_id = response.data.batch_id;
            api_success = true;
            // console.log("BatchAdd API.put: new batch_id=", new_id);
          })
          .catch(error => {
            console.log("BatchAdd API.put Error:", error);
            // alert("API.put error");
              this.alertText = "Database put error.";
              this.alertStyle="danger";
              this.isUploading = false;
          });

        if (api_success) {
          await Storage.put(
            `batch_${new_id}_metrics.zip`,
            this.output_file
          )
            .then(result => {
              console.log("BatchAdd Storage.put: ", result);
              this.alertText = "File uploaded successfully.";
              this.alertStyle="success";
              this.isUploading = false;

            })
            .catch(err => {
              console.log("BatchAdd Storage.put Error:", err);
            //   alert("Storage.put error");
              this.alertText = "File upload error.";
              this.alertStyle="danger";
              this.isUploading = false;
            });
        }
      }

      //   alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.customer = "";
      this.form.descr = "";
      this.output_file = null;
      this.$refs.fileinput.reset();
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style>
</style>
